import { render } from "./CreateBlog.vue?vue&type=template&id=8cf8faee&scoped=true"
import script from "./CreateBlog.vue?vue&type=script&lang=js"
export * from "./CreateBlog.vue?vue&type=script&lang=js"

import "./CreateBlog.vue?vue&type=style&index=0&id=8cf8faee&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf8faee"]])

export default __exports__